<!-- Without login -->
<app-http-loader></app-http-loader>
<router-outlet></router-outlet>
<!-- Without login -->